module.exports = __webpack_public_path__ + "static/media/icon-graphic-matched.209ef66e.svg";